import React, {useReducer} from 'react';
import sanityClient from '../../client';
import ProjectReducer from './projectReducer';
import ProjectContext from './projectContext';
import {LOADING, ERROR, CLEAR_ERRORS, GET_PROJECTS} from "../types";

const ProjectState = (props) => {
  const initialState = {
    projects: null,
    error: null,
    loading: false
  }

  const [state, dispatch] = useReducer(ProjectReducer, initialState);

  // methods
  const getProjects = async () => {
    setLoading();

    try {
      const data = await sanityClient.fetch(`*[_type == "project"]{
            name,
            description,
            githubLink,
            deployedLink,
            previewImage,
            galleryImage,
            tags
        }`)
      console.log(data)
      dispatch({
        type: GET_PROJECTS,
        payload: data,
      })
    } catch (err) {
      dispatch({
        type: ERROR,
        payload: err,
      })
    }
  }

  const setLoading = () => {
    dispatch({
      type: LOADING
    })
  }

  const clearErrors = () => {
    dispatch({
      type: CLEAR_ERRORS
    })
  }

  return (
    <ProjectContext.Provider value={{
      projects: state.projects,
      loading: state.loading,
      error: state.error,
      getProjects,
      setLoading,
      clearErrors,
    }}>
      {props.children}
    </ProjectContext.Provider>
  );
};

export default ProjectState;
